import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { StepContainer, StepContent, StepDescription, StepHeading, StepNavigator } from '../../components';
import { Button } from '@uplift/ui-v2';

export type AssessmentEntryProps = {
  onNext: () => void;
  onBack: () => void;
};

export const AssessmentEntry: React.VFC<AssessmentEntryProps> = props => {
  const { classes } = useAssessmentEntryStyles();

  return (
    <StepContainer className={classes.container}>
      <StepContent className={classes.content}>
        <StepHeading>
            It’s okay to be unsure—
          <Typography component="span" color="secondary" variant="inherit"><br />we can help you decide</Typography>
        </StepHeading>
        <StepDescription>
            Let’s start by checking how you’ve been feeling these past 2 weeks.
        </StepDescription>
      </StepContent>
      <StepNavigator onBack={props.onBack}>
        <Button variant="contained" color="secondary" onClick={props.onNext}>Continue</Button>
      </StepNavigator>
    </StepContainer>
  );
};

const useAssessmentEntryStyles = makeStyles({ name: 'AssessmentEntry' })(theme => ({
  container: {
    background: 'linear-gradient(205.7deg, #F7F2FF 30.17%, #FFFFFF 83.75%)',
    [theme.breakpoints.up('md')]: {
      background: 'unset',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));
